import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Menu, Dropdown, Badge, Avatar, List, Button, Modal } from 'antd';
import { 
  MailOutlined, 
  BellOutlined, 
  WarningOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import Flex from 'components/shared-components/Flex';
import Loader from 'components/util-components/Loader';
import { getNotificationData, clearNotification, readNotification, deleteNotifications, deleteNotification, resendInvitation } from "redux/actions/user";
import { API_ENDPOINT_UI_URL } from 'configs/AppConfig';


const getIcon =  icon => {
  switch (icon) {
    case 'mail':
      return <MailOutlined />;
    case 'alert':
      return <WarningOutlined />;
    case 'check':
      return <CheckCircleOutlined />
    default:
      return <MailOutlined />;
  }
}

const navigateWithLoading = (setActionLoading, url) => {
  setActionLoading(true);
  requestAnimationFrame(() => {
    window.location.href = url;
  });
};

const getNotificationBody = (list, readNotification, deleteNotification, resendInvitation, setActionLoading, isNotificationLoading) => {
  const onResendInvitation = (key)=>{
    resendInvitation({key});
  }

  const onGrantAccess = (websiteUrl) => {
    navigateWithLoading(setActionLoading, decodeURIComponent(websiteUrl));
  };

  const onDenyAccess = (notificationId) => {
    navigateWithLoading(
      setActionLoading,
      `${API_ENDPOINT_UI_URL}/admin/auth/access-decline?nId=${notificationId}`
    );
  };

  const onDeleteNotification=(notification, onActionStart)=>{
    var title =`Do you want to delete the notification?`;
		Modal.confirm({
			title: title,
			icon: <ExclamationCircleOutlined />,
			okText: 'Yes',
			cancelText: 'Cancel',
      visible:true,
      style:{},
			onOk() {
        onActionStart();
        deleteNotification(notification);
			},
		});
  }
  return list.length > 0 ?
  <List
    size="small"
    itemLayout="horizontal"
    dataSource={list}
    renderItem={item => (
      <List.Item className="list-clickable">
        <div>
        <Flex alignItems="center">
          <div className="pr-3" >
            {item.img? <Avatar style={{backgroundColor:"#699dff"}}  src={`/img/avatars/${item.img}`} /> : <Avatar style={{backgroundColor:"#699dff"}} className={`ant-avatar-${item.type}`} icon={getIcon(item.icon)} />}
            </div>
          <div className="pr-3">
            <span style={item.readDatetime === null ? { color:'blue' } : {}} className="ml-auto">{item.message}</span>
          </div>
          <div className="mr-3">
          <small style={item.readDatetime === null ? {color:'blue' } : {}} className="ml-auto">{item.sentDatetime}</small>
          </div>
            {item?.websiteUrl?.includes("key")?<div className="mr-3">
        {item.message.includes(" request to resend invitaion")? 
          <button type="primary" className="ant-btn ant-btn-primary ant-btn-sm" onClick={()=>{onResendInvitation(item.key)}} >Resend</button>
          :<a href={`${item.websiteUrl}`} rel="noopener noreferrer">
        <button type="primary" disabled={item.actionDatetime!==undefined && item.actionDatetime!==null && item.actionDatetime.trim()!==""} className="ant-btn ant-btn-primary ant-btn-sm">Accept</button>
        </a>}</div>:<>
        <div className="mr-3">
          <Button
            type="primary"
            className="ant-btn ant-btn-primary ant-btn-sm"
            disabled={isNotificationLoading}
            onClick={() => onGrantAccess(item.websiteUrl)}
          >
            {item?.message?.includes("requesting access") ? 'Grant' : 'Download'}
          </Button>
          </div>
          <div className="mr-3">
          {item?.message?.includes("requesting access") ? (
            <Button
              type="primary"
              className="ant-btn ant-btn-primary ant-btn-sm"
              disabled={isNotificationLoading}
              onClick={() => onDenyAccess(item.id)}
            >
              Deny
            </Button>
          ) : null}
       </div>
       </>
        }
<div className="mr-3">
<button type="primary" disabled={isNotificationLoading} className="ant-btn ant-btn-primary ant-btn-sm" style={{background: "#fff1f0",borderColor: "#ffa39e",color: "#cf1322"}} onClick={() => onDeleteNotification(item, () => setActionLoading(true))}>Delete</button>
          </div>
        </Flex>
        </div>
      </List.Item>
    )}
  />
  :
  <div className="empty-notification">
    <img src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg" alt="empty" />
    <p className="mt-3">You have viewed all notifications</p>
  </div>;
}

export const NavNotification = (props) => {
	const { notificationData, getNotificationData, clearNotification, readNotification, deleteNotifications, deleteNotification, resendInvitation } = props;
  const { notificationDataList, notificationLoading } = notificationData
  const [visible, setVisible] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const isNotificationLoading = notificationLoading || actionLoading;

  const startNotificationAction = () => {
    setActionLoading(true);
  };

  useEffect(() => {
    if (!notificationLoading) {
      setActionLoading(false);
    }
  }, [notificationLoading]);

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  }

  const clearNotificationData = () =>{
    clearNotification();
  }

  const deleteNotificationData=()=>{
    var title =`Do you want to delete all notification?`;
		Modal.confirm({
			title: title,
			icon: <ExclamationCircleOutlined />,
			okText: 'Yes',
			cancelText: 'Cancel',
			onOk() {
				startNotificationAction();
				deleteNotifications()
			},
		});
  }
  useEffect(() => {
    getNotificationData();
  },[])

  let filteredNotificationDataList =[];
  if(notificationDataList && notificationDataList.length>0){
    filteredNotificationDataList= notificationDataList.filter(notification => {
    return notification.readDatetime === null;
    });
    }

  const notificationList = (
    <div className="nav-dropdown nav-notification">
      <div className="nav-notification-header d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Notification</h4>
        <div>
         <Button disabled={notificationDataList.length<=0 || isNotificationLoading} className="text-primary" type="text" onClick={() => clearNotificationData()} size="small">Read all </Button> 
         <Button disabled={notificationDataList.length<=0 || isNotificationLoading} className="text-primary" type="text" onClick={() => deleteNotificationData()} size="small">Delete all </Button> 
         </div>
      </div>
      <div className="nav-notification-body">
        {getNotificationBody(notificationDataList, readNotification, deleteNotification, resendInvitation, setActionLoading, isNotificationLoading)}
      </div>
      {
        notificationDataList.length > 0 ? 
        <div className="nav-notification-footer">
        </div>
        :
        null
      }
    </div>
  );

  return (<>
    {isNotificationLoading ? <Loader spinning={isNotificationLoading} cover="page" message="Loading..." /> : null}
    <Dropdown 
      placement="bottomRight"
      overlay={notificationList}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      trigger={['click']}
    >
      <Menu mode="horizontal">
        <Menu.Item key="notification">
          <Badge count={filteredNotificationDataList.length}>
            <BellOutlined className="nav-icon mx-auto" type="bell" />
          </Badge>
        </Menu.Item>
      </Menu>
    </Dropdown>
    </>
  )
}

const mapStateToProps = state => ({
	notificationData: state.user,
});
export default connect(
  mapStateToProps,
  { getNotificationData, clearNotification, readNotification, deleteNotifications, deleteNotification, resendInvitation }
)(NavNotification);
